import { render, staticRenderFns } from "./CreateItemModal.vue?vue&type=template&id=36efd6ea&scoped=true"
import script from "./CreateItemModal.vue?vue&type=script&lang=js"
export * from "./CreateItemModal.vue?vue&type=script&lang=js"
import style0 from "./CreateItemModal.vue?vue&type=style&index=0&id=36efd6ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36efd6ea",
  null
  
)

export default component.exports